import { render, staticRenderFns } from "./info-type.vue?vue&type=template&id=92945ca6&scoped=true"
import script from "./info-type.vue?vue&type=script&lang=js"
export * from "./info-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92945ca6",
  null
  
)

export default component.exports